var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoIconeMu = function SvgLogoIconeMu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 31"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FDFDFD",
    d: "M25.62 4.293a15.08 15.08 0 1 0-.06 21.631 12.327 12.327 0 0 0 .06-21.631m-.896 2.618a12.6 12.6 0 0 1 .086 16.239 9.3 9.3 0 0 1-4.754 1.34 9.442 9.442 0 0 1-.078-18.879 9.3 9.3 0 0 1 4.746 1.3m-9.612 20.8A12.63 12.63 0 0 1 4.352 8.416a12.63 12.63 0 0 1 14.01-5.527 12.297 12.297 0 0 0 0 24.398c-1.066.28-2.163.42-3.265.416z"
  })));
};
export default SvgLogoIconeMu;